import { temAcesso } from '@/shared/auth/temAcesso'

const PainelErrosComprometimentos = () =>
    import('./PainelErrosComprometimentos.vue')
// const Entrega = () => import('./Entrega.vue')

export default {
    path: 'paineis',
    name: 'Gestores_Paineis',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GEST-PNL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'erroscomprometimentos',
            name: 'Gestores_Paineis_Erros_Comprometimentos',
            component: PainelErrosComprometimentos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CRED-GEST-PNL-01')) {
                    next()
                }
            }
        }
    ]
}
